var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4ContactsSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.4 7.2A1.6 1.6 0 10.8 5.6c0 .882.718 1.6 1.6 1.6zm11.2 0A1.6 1.6 0 1012 5.6c0 .882.717 1.6 1.6 1.6zm.8.8h-1.6c-.44 0-.838.177-1.128.465A3.657 3.657 0 0113.55 11.2h1.65a.8.8 0 00.8-.8v-.8A1.6 1.6 0 0014.4 8zM8 8a2.8 2.8 0 100-5.6 2.799 2.799 0 00-2.8 2.8C5.2 6.747 6.452 8 8 8zm1.92.8h-.207c-.52.25-1.098.4-1.713.4s-1.19-.15-1.713-.4H6.08a2.88 2.88 0 00-2.88 2.88v.72a1.2 1.2 0 001.2 1.2h7.2a1.2 1.2 0 001.2-1.2v-.72A2.88 2.88 0 009.92 8.8zm-5.593-.335A1.595 1.595 0 003.2 8H1.6A1.6 1.6 0 000 9.6v.8a.8.8 0 00.8.8h1.647a3.666 3.666 0 011.88-2.735z",
    fill: "#9FA2B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4ContactsSvg);
export default __webpack_public_path__ + "static/media/_4ContactsSvg.c44d5a068075999f01b4ee1d1c657c50.svg";
export { ForwardRef as ReactComponent };